
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import { LagerlisteFilter } from '@/store/lagerfuehrung';

    @Component({
        computed: {
            ...mapState('authentication', ['user']),
            ...mapGetters('authentication', ['impfstelleDetail']),
            ...mapState('lagerfuehrung', ['loaders', 'lagerliste']),
            ...mapGetters('authentication', ['isAllowed', 'getSystemEinstellung']),
        },
        methods: {
            ...mapActions('lagerfuehrung', ['loadLagerliste', 'printLagerliste', 'exportLagerliste']),
        },
    })
    export default class Lagerliste extends Vue {
        @Prop() visible!: boolean;
        @Prop({ default: () => ({ gueltig: 'j' })}) mainFilter!: LagerlisteFilter;

        public filter: LagerlisteFilter = {
            verfuegbar: true,
            alleImpfstellen: false,
            preis_muw: false,
        };

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.filter.verfuegbar = true;
                this.filter.alleImpfstellen = false;
                this.filter.preis_muw = false;
            }
        }
    }
